/**
 * Money for the Host Panel, in **integer cents**.
 *
 * Panel aggregates are sums over dozens of entries, and float addition accumulates error
 * exactly where it cannot appear: handoff criterion 1 requires the panel and the statement
 * to agree digit for digit. Formatting returns the absolute value, so the sign is the
 * presenter's decision.
 */

const BRL_FORMATTER = new Intl.NumberFormat("pt-BR", {
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
});

const BRL_INTEGER_FORMATTER = new Intl.NumberFormat("pt-BR", {
  maximumFractionDigits: 0,
});

/** "17.895,00" — no currency symbol and no sign. */
export function formatBrl(cents: number): string {
  return BRL_FORMATTER.format(Math.abs(cents) / 100);
}

/** "2.400" — the rounded total, as the prototype shows it on drawer pieces. */
export function formatBrlInteger(cents: number): string {
  return BRL_INTEGER_FORMATTER.format(Math.round(Math.abs(cents) / 100));
}

/** Integer part and cents apart, for the credit KPI that sets cents smaller. */
export function splitBrl(cents: number): { integer: string; cents: string } {
  const [integer, fraction] = formatBrl(cents).split(",");

  return { integer, cents: fraction };
}

/** Plain pt-BR count ("1.284" visitors). */
export function formatCount(value: number): string {
  return BRL_INTEGER_FORMATTER.format(value);
}

/** Whole reais to cents, so a price ladder written in reais reads without noise. */
export function reaisToCents(reais: number): number {
  return Math.round(reais * 100);
}
